export const contactIntro =
    'Email is the quickest way to reach me, or use the form to send a message!'

export const contactLinks = [
    {
        label: 'Email',
        text: 'hoffmann.jesse@gmail.com',
        href: 'mailto:hoffmann.jesse@gmail.com',
    },
    {
        label: 'LinkedIn',
        text: 'linkedin.com/in/jessehoffmann',
        compactText: 'jessehoffmann',
        href: 'https://www.linkedin.com/in/jessehoffmann/',
    },
    {
        label: 'GitHub',
        text: 'github.com/jessehoffmann',
        compactText: 'jessehoffmann',
        href: 'https://github.com/jessehoffmann',
    },
]
